import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard, LeadGuard } from "../shared";
import { PagesComponent } from "./pages.component";

export const routes: Routes = [
  {
    path: "",
    component: PagesComponent,
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "clientes",
        canActivate: [AuthGuard],
      },

      {
        path: "dashboard",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
        canActivate: [AuthGuard],
      },
      {
        path: "roles",
        loadChildren: () =>
          import("./roles/roles.module").then((m) => m.RolesModule),
        canActivate: [AuthGuard],
      },
      {
        path: "users",
        loadChildren: () =>
          import("./users/users.module").then((m) => m.UsersModule),
        canActivate: [AuthGuard],
      },
      {
        path: "sign-up",
        loadChildren: () =>
          import("./sign-up/sign-up.module").then((m) => m.SignUpModule),
        canActivate: [],
      },
      {
        path: "contacts",
        loadChildren: () =>
          import("./contacts/contacts.module").then((m) => m.ContactsModule),
        canActivate: [AuthGuard],
      },
      {
        path: "object-manager",
        loadChildren: () =>
          import("./object-manager/object-manager.module").then((m) => m.ObjectManagerModule),
        canActivate: [AuthGuard],
      },
      {
        path: "list-of-val",
        loadChildren: () =>
          import("./list-of-val/list-of-val.module").then((m) => m.ListOfValModule),
        canActivate: [AuthGuard],
      },
      { path: "**", redirectTo: "clientes" },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
